class FreeShippingMeter extends HTMLElement {
  constructor() {
    super();
  }

  static freeShippingText = window.free_shipping_text?.free_shipping_message || '';
  static freeShippingText1 = window.free_shipping_text?.free_shipping_message_1 || '';
  static freeShippingText2 = window.free_shipping_text?.free_shipping_message_2 || '';
  static freeShippingText3 = window.free_shipping_text?.free_shipping_message_3 || '';
  static freeShippingText4 = window.free_shipping_text?.free_shipping_message_4 || '';
  static classLabel1 = 'progress-30';
  static classLabel2 = 'progress-60';
  static classLabel3 = 'progress-100';
  static freeshipPrice = parseFloat(window.free_shipping_price || 0);

  connectedCallback() {
    this.freeShippingEligible = 0;
    this.progressBar = this.querySelector('[data-shipping-progress]');
    this.messageElement = this.querySelector('[data-shipping-message]');
    this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
    this.shipVal = window.free_shipping_text?.free_shipping_1 || '';
    this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

    this.addEventListener('change', this.onCartChange.bind(this));

    document.addEventListener('currency:changed', this.onCartChange.bind(this), { passive: true });
    document.addEventListener('currency:change', this.onCartChange.bind(this), { passive: true });
    document.addEventListener('shopify:region:change', this.onCartChange.bind(this), { passive: true });

    this.initialize();
  }

  initialize() {
    const price = parseFloat(window.free_shipping_price);
    if (!Number.isNaN(price)) {
      FreeShippingMeter.freeshipPrice = price;
    }

    Shopify.getCart((cart) => {
      this.cart = cart;
      this.calculateProgress(cart);
    });
  }

  onCartChange() {
    this.initialize();
  }

  getEligibleCartTotal(cart) {
    let totalPrice = cart.total_price;

    if ($('body').hasClass('setup_shipping_delivery')) {
      const giftCardItems = $('.cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]');

      if (giftCardItems.length > 0) {
        giftCardItems.each(function () {
          totalPrice -= parseFloat($(this).attr('data-price-gift-card'));
        });
      }
    }

    const cartTotalPrice = parseInt(totalPrice, 10) / 100;
    const cartTotalPriceFormatted = cartTotalPrice.toFixed(2);

    return parseFloat(cartTotalPriceFormatted);
  }

  calculateProgress(cart) {
    const coreConfig = window.celvian_core_shipping || null;

    if (coreConfig && coreConfig.enabled) {
      this.calculateCoreShippingProgress(cart, coreConfig);
      return;
    }

    this.calculateLegacyProgress(cart);
  }

  calculateCoreShippingProgress(cart, config) {
    const cartTotalPrice = this.getEligibleCartTotal(cart);
    const threshold = Number(config.threshold);
    const tier = String(config.tier || '');
    const supported = Boolean(config.supported);

    const previewCartMessage = this.closest('.previewCartMessage');

    if (previewCartMessage) {
    previewCartMessage.style.display = supported ? '' : 'none';
    }

    if (!supported || threshold < 0) {
        if (previewCartMessage) {
            previewCartMessage.style.display = 'none';
        }

        this.setProgressWidthAndText(
            0,
            '',
            'none',
            true
        );

        return;
    }

    if (tier === 'dedicated_plus' && threshold === 0) {
        this.freeShippingEligible = 1;

        this.setProgressWidthAndText(
        100,
        '<span>Free standard shipping unlocked.</span>',
        'progress-free',
        false
        );
        return;
    }

    if (threshold > 0) {
        let freeShipBar = Math.abs((cartTotalPrice * 100) / threshold);

        if (freeShipBar >= 100) {
        freeShipBar = 100;
        }

        const classLabel = this.getClassLabel(freeShipBar);

        if (cartTotalPrice >= threshold) {
        this.freeShippingEligible = 1;

        let unlockedText = 'Free shipping unlocked.';

        if (tier === 'training') {
            unlockedText = 'Training Core free shipping unlocked.';
        }

        this.setProgressWidthAndText(
            100,
            '<span>' + unlockedText + '</span>',
            'progress-free',
            false
        );

        return;
        }

        const remainingPrice = Math.max(0, threshold - cartTotalPrice);

        let message = '<span>Add </span>' + this.formatMoney(remainingPrice * 100) + '<span> for free shipping.</span>';

        if (tier === 'training') {
        message = '<span>Add </span>' + this.formatMoney(remainingPrice * 100) + '<span> for Training Core free shipping.</span>';
        }

        this.setProgressWidthAndText(
        freeShipBar,
        message,
        classLabel,
        false
        );

        return;
    }

    this.calculateLegacyProgress(cart);
    }

  calculateLegacyProgress(cart) {
    const cartTotalPrice = this.getEligibleCartTotal(cart);
    const threshold = Number(FreeShippingMeter.freeshipPrice || 0);

    if (!threshold || threshold <= 0) {
      this.setProgressWidthAndText(
        0,
        '<span>Shipping calculated at checkout.</span>',
        'none',
        true
      );
      return;
    }

    let freeShipBar = Math.abs((cartTotalPrice * 100) / threshold);

    if (freeShipBar >= 100) {
      freeShipBar = 100;
    }

    const text = this.getText(cartTotalPrice, freeShipBar);
    const classLabel = this.getClassLabel(freeShipBar);

    this.setProgressWidthAndText(freeShipBar, text, classLabel, false);
  }

  getText(cartTotalPrice) {
    let text;

    if (cartTotalPrice === 0) {
      this.progressBar?.classList.add('progress-hidden');
      text = '<span>' + FreeShippingMeter.freeShippingText + ' ' + this.formatMoney(FreeShippingMeter.freeshipPrice * 100) + '!</span>';
    } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
      this.progressBar?.classList.remove('progress-hidden');
      this.freeShippingEligible = 1;
      text = FreeShippingMeter.freeShippingText1;
    } else {
      this.progressBar?.classList.remove('progress-hidden');
      const remainingPrice = Math.abs(FreeShippingMeter.freeshipPrice - cartTotalPrice);

      text =
        '<span>' +
        FreeShippingMeter.freeShippingText2 +
        ' </span>' +
        this.formatMoney(remainingPrice * 100) +
        '<span> ' +
        FreeShippingMeter.freeShippingText3 +
        ' </span><span class="text">' +
        FreeShippingMeter.freeShippingText4 +
        '</span>';

      this.shipVal = window.free_shipping_text?.free_shipping_2 || '';
    }

    return text;
  }

  getClassLabel(freeShipBar) {
    let classLabel;

    if (freeShipBar === 0) {
      classLabel = 'none';
    } else if (freeShipBar <= 30) {
      classLabel = FreeShippingMeter.classLabel1;
    } else if (freeShipBar <= 60) {
      classLabel = FreeShippingMeter.classLabel2;
    } else if (freeShipBar < 100) {
      classLabel = FreeShippingMeter.classLabel3;
    } else {
      classLabel = 'progress-free';
    }

    return classLabel;
  }

  resetProgressClass(classLabel) {
    if (!this.progressBar) return;

    this.progressBar.classList.remove('progress-30');
    this.progressBar.classList.remove('progress-60');
    this.progressBar.classList.remove('progress-100');
    this.progressBar.classList.remove('progress-free');

    if (classLabel) {
      this.progressBar.classList.add(classLabel);
    }
  }

  setProgressWidthAndText(freeShipBar, text, classLabel, hideProgress) {
    setTimeout(() => {
      this.resetProgressClass(classLabel);

      if (this.progressBar) {
        this.progressBar.classList.toggle('progress-hidden', Boolean(hideProgress));
      }

      if (this.progressMeter) {
        this.progressMeter.style.width = `${freeShipBar}%`;

        if (this.textEnabled) {
          const textEl = this.progressMeter.querySelector('.text');
          if (textEl) textEl.innerHTML = `${freeShipBar.toFixed(2)}%`;
        }
      }

      if (this.messageElement) {
        this.messageElement.innerHTML = text;
      }

      if ($('.dropdown-item[data-currency]').length) {
        if (
          (window.show_multiple_currencies && typeof Currency !== 'undefined' && Currency.currentCurrency !== shopCurrency) ||
          window.show_auto_currency
        ) {
          Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
        }
      }
    }, 400);
  }

  formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.money_format);
    }

    return '€' + (Number(cents || 0) / 100).toFixed(2);
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}

window.addEventListener('load', () => {
  if (!customElements.get('free-shipping-component')) {
    customElements.define('free-shipping-component', FreeShippingMeter);
  }
});